import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { Fragment } from 'react/jsx-runtime'
const pages = [
  { name: "Keywords", href: "/keywords", current: true },
];
export default function Keywords() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="keywords">
        <BreadcrumbsNew pages={pages} />
       </SidebarLayoutNew>
    </Fragment>
  );
}